import React, { useState, useRef } from 'react';
import { Input }         from '@/components/ui/inputs/input';
import { InputSelect }   from '@/components/ui/inputs/input-select';
import { useForm, Controller } from 'react-hook-form';
import ToastMe from '@/components/ui/ToastMe';

const DataTableFilter = ({ onChangeFilter }) => {
  const selectRef = useRef(null);
  const {
    register, setValue, getValues,
    formState: { errors },
    handleSubmit, control, reset,
  } = useForm({
    defaultValues: { name: '', email: '', phone_no: '', status: '' },
    mode: 'onSubmit',
  });

  const statusOptionList = [
    { value: 1, label: 'Active' },
    { value: 2, label: 'Inactive' },
  ];

  const convertUndefinedToBlank = (obj) =>
    Object.fromEntries(Object.entries(obj)
      .map(([k,v]) => [k, v===undefined ? '' : v])
    );

  const clearSelection = () => selectRef.current?.clearValue();

  const formReset = async () => {
    try {
      const values = getValues();
      for (let key in values) await setValue(key, '');
      reset();
      clearSelection();
      onChangeFilter('extra_filter', {});
    } catch (error) {
      const errorMsg = error?.message || 'Error resetting filter';
      ToastMe(errorMsg, 'error');
      console.error('[WaitersFilter] Reset error:', error);
    }
  };

  const onSubmit = (data) => {
    try {
      const filterData = convertUndefinedToBlank(data);
      onChangeFilter('extra_filter', filterData);
    } catch (error) {
      const errorMsg = error?.message || 'Error applying filter';
      ToastMe(errorMsg, 'error');
      console.error('[WaitersFilter] Error:', error);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="p-4 sm:p-5 mb-5">
      <div className="row">
        {/* Name */}
        <div className="col-12 sm:col-6 md:col-4 xl:col-3">
          <Controller
            name="name" control={control}
            render={({ field }) =>
              <Input {...field} size="sm" labelText="Name"
                type="text" className="db-field-control"
                labelStyleClassName="db-field-title after:hidden"
              />}
          />
        </div>

        {/* Email */}
        <div className="col-12 sm:col-6 md:col-4 xl:col-3">
          <Controller
            name="email" control={control}
            render={({ field }) =>
              <Input {...field} size="sm" labelText="Email"
                type="email" className="db-field-control"
                labelStyleClassName="db-field-title after:hidden"
              />}
          />
        </div>

        {/* Phone */}
        <div className="col-12 sm:col-6 md:col-4 xl:col-3">
          <Controller
            name="phone_no" control={control}
            render={({ field }) =>
              <Input {...field} size="sm" labelText="Phone"
                type="text" className="db-field-control"
                labelStyleClassName="db-field-title after:hidden"
              />}
          />
        </div>

        {/* Status */}
        <div className="col-12 sm:col-6 md:col-4 xl:col-3">
          <Controller
            name="status" control={control}
            render={({ field }) =>
              <InputSelect
                {...field} ref={selectRef}
                id="status" size="sm"
                labelText="Status"
                labelStyleClassName="db-field-title after:hidden"
                value={statusOptionList.find(o => o.value === getValues('status')) || null}
                onChange={e => setValue('status', e)}
                options={statusOptionList}
              />}
          />
        </div>

        {/* Buttons */}
        <div className="col-12">
          <div className="flex flex-wrap gap-3 mt-4">
            <button type="submit" className="db-btn py-2 text-white bg-primary">
              <i className="lab lab-search-line lab-font-size-16"></i>
              <span>Search</span>
            </button>
            <button type="button" onClick={formReset} className="db-btn py-2 text-white bg-gray-600">
              <i className="lab lab-cross-line-2 lab-font-size-22"></i>
              <span>Clear</span>
            </button>
          </div>
        </div>
      </div>
    </form>
  );
};

export default DataTableFilter;
